module.exports = __webpack_public_path__ + "static/media/2019-01-31-01.2ab1dc5c.png";